export default "__VITE_ASSET__hn$6d74H__"